const path = "brands";

export const FETCH_BRANDS_REQUEST = `${path}/FETCH_BRANDS_REQUEST`;
export const FETCH_BRANDS_SUCCESS = `${path}/FETCH_BRANDS_SUCCESS`;
export const FETCH_BRANDS_FAILURE = `${path}/FETCH_BRANDS_FAILURE`;
export const FETCH_BRANDS_CANCEL = `${path}/FETCH_BRANDS_CANCEL`;
export const CLEAR_BRANDS = `${path}/CLEAR_BRANDS`;
